document.addEventListener('DOMContentLoaded', () => {
  const locationData = window.locationData;
  const userCountry = window.userCountry;

  function mergeInventory(arrays) {
    // если передан только один массив — возвращаем его
    if (arrays.length === 1) return arrays[0];

    const map = new Map();

    arrays.forEach((arr) => {
      arr.forEach((item) => {
        const existing = map.get(item.loc);
        if (!existing || item.quantity > existing.quantity) {
          map.set(item.loc, item);
        }
      });
    });

    return Array.from(map.values());
  }

  const getAvailableLocations = (country, locations) =>
    Object.entries(locations)
      .filter(([_, location]) => location.countries.includes(country))
      .map(([id]) => id);

  const availableLocations = getAvailableLocations(userCountry, locationData);

  const checkItemStock = (item) => {
    let inventoryData = [];

    if (item.classList.contains('item-variation-item-color')) {
      inventoryData = JSON.parse(item.dataset.inventoryLocations || '[]');
      if (!inventoryData.length) return;
    } else {
      let inventoryDataMap = item.dataset.inventoryLocations;

      if (!inventoryDataMap.length || !inventoryDataMap) return;

      inventoryDataMap = '[' + inventoryDataMap.replace(/],\s*\[/g, '],[') + ']';

      const lastIndex = inventoryDataMap.lastIndexOf(', ]');

      inventoryDataMap =
        lastIndex === -1 ? inventoryDataMap : inventoryDataMap.slice(0, lastIndex) + ']' + inventoryDataMap.slice(lastIndex + 3);

      const result = JSON.parse(inventoryDataMap);

      inventoryData = mergeInventory(result);
    }

    const quantities = inventoryData.filter((i) => availableLocations.includes(String(i.loc))).map((i) => i.quantity);

    const cartBadgeWrapper = item.querySelector('.cart-product-item-badge-wrp');

    if (quantities.every((q) => q <= 0)) {
      item.classList.add('out-of-stock');
      if (
        item.classList.contains('accessories-list-item') ||
        item.classList.contains('cart-product-item') ||
        item.classList.contains('product-selector-item')
      ) {
        const outOfStockText = item.querySelector('.out-of-stock-text');
        if (outOfStockText) outOfStockText.style.display = 'flex';

        const outOfStockBadge = item.querySelector('.product-discount-badge-out-of-stock');
        if (outOfStockBadge) outOfStockBadge.style.display = 'inline-block';
      }
      const oldPriceBadge = item.querySelector('.desktop-menu-submenu-item-old-price');
      if (oldPriceBadge) oldPriceBadge.style.display = 'none';

      if (cartBadgeWrapper) {
        cartBadgeWrapper.querySelector('.product-discount-badge-out-of-stock').style.display = 'inline-block';
        cartBadgeWrapper.querySelector('.product-discount-badge').style.display = 'none';
      }

      const radioInput = item.querySelector('.product-variant-selector-radio');
      if (radioInput) radioInput.disabled = true;

      const buttonWrp = item.querySelector('.cart-product-item-button-wrp');
      if (buttonWrp) buttonWrp.style.display = 'none';
    } else {
      const perUnitWrp = item.querySelector('.cart-product-item-per-unit-wrp');
      if (perUnitWrp) perUnitWrp.style.display = 'flex';

      if (cartBadgeWrapper) {
        const cartBadgeOutOfStock = cartBadgeWrapper.querySelector('.product-discount-badge-out-of-stock');
        const cartBadge = cartBadgeWrapper.querySelector('.product-discount-badge');
        if (cartBadgeOutOfStock) cartBadgeOutOfStock.style.display = 'none';
        if (cartBadge) cartBadge.style.display = 'inline-block';
      }
    }
  };

  document
    .querySelectorAll(
      '.desktop-menu-submenu-item, .mobile-menu-product-item, .mobile-menu-accessories-item, .product-selector-item, .accessories-list-item, .cart-product-item, .item-variation-item-color',
    )
    .forEach(checkItemStock);

  setTimeout(() => {
    document.querySelectorAll('.item-variation-item-colors').forEach((variationItemColors) => {
      let enableNext = false;
      let prevAvailable = null;
      variationItemColors.querySelectorAll('.item-variation-item-color').forEach((colorItem) => {
        const selectorRadio = colorItem.querySelector('.product-variant-selector-radio');
        if (!selectorRadio.disabled && !prevAvailable) {
          prevAvailable = true;
          selectorRadio.checked = true;
        }
        if (selectorRadio && selectorRadio.disabled) {
          selectorRadio.checked = false;
          selectorRadio.removeAttribute('checked');
          enableNext = true;
        }
        if (enableNext && !selectorRadio.disabled && !prevAvailable) {
          console.log('selecting available variant');
          selectorRadio.checked = true;
          enableNext = false;
        }
      });
    });
  }, 1000);
});
